import Head from 'next/head'
import React from 'react'
import RealestateList from 'shared/components-pages/proyectos/RealestateList'
import HeadMeta, { IHeadMetaComponent } from 'shared/components/head-meta'
import { IProjectList } from 'shared/components-pages/proyectos/ProjectList'
import { CPagesPath } from 'shared/models/const/pages-path'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'

import type { GetStaticPropsContext, NextPage } from "next";
export async function getStaticProps({ locale }: GetStaticPropsContext) {

  return {
    props: {
      locale,
      messages: (await import(`../../../lang/${locale}.json`)).default,
    },
  };
}

const PropiedadesCollection: NextPage = (props: any) => {
  const router = useRouter()
  const filters: IProjectList = {
    refRequest: "Propiedades-collection",
    detailPath: CPagesPath.es.collection_property_detail,
    filters: {
      collection: true,
    },
  };

  const metaData: IHeadMetaComponent = {
    title: "collectionProperties",
    description: "collectionProperties",
    url:router.asPath,
    og_type: "properties-list",
  }

  return (
    <>
      <HeadMeta {...metaData} />
      <RealestateList defaultFilters={filters} collection={true} />
    </>
  );
};

export default PropiedadesCollection;
